module.exports = __webpack_public_path__ + "img/plan1_s.d87f2d5d.svg";